import { render, staticRenderFns } from "./CultureCard.vue?vue&type=template&id=df45d7fa&scoped=true"
import script from "./CultureCard.vue?vue&type=script&lang=js"
export * from "./CultureCard.vue?vue&type=script&lang=js"
import style0 from "./CultureCard.vue?vue&type=style&index=0&id=df45d7fa&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df45d7fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df45d7fa')) {
      api.createRecord('df45d7fa', component.options)
    } else {
      api.reload('df45d7fa', component.options)
    }
    module.hot.accept("./CultureCard.vue?vue&type=template&id=df45d7fa&scoped=true", function () {
      api.rerender('df45d7fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aboutUS/components/CultureCard.vue"
export default component.exports